import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function MindmapPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="mindmap" />

    </>
  );
}

export default MindmapPhysTopics;